// Нормализовать целое число (строкой) из URL query или URL params.
export function normalizeNumberFromUrl(
    numericString: string | number | null | undefined
): number | null {
    if (typeof numericString === 'number') {
        return numericString
    }
    if (typeof numericString !== 'string' || numericString.trim().length === 0) {
        return null
    }
    const int = parseInt(numericString.trim())
    return isNaN(int) ? null : int
}
